/* eslint-disable no-undef */
export default class Configuration {
  static get CONFIG() {
    return {
      authRedirectURL: EMOC_AUTH_REDIRECT_URL,
      authClientID: EMOC_AUTH_CLIENTID,
      authAuthority: EMOC_AUTH_AUTHORITY,
      adminEndPoint: EMOC_SERVICES_ADMIN_URL,
      authLogLevel: EMOC_AUTH_LOGLEVEL,
      uiEndPoint: EMOC_SERVICES_UI_URL,
      tasksEndPoint: EMOC_SERVICES_TASKS_URL,
      approvalEndPoint: EMOC_SERVICES_APPROVAL_URL,
      qaRelationshipsEndPoint: EMOC_SERVICES_QARELATIONSHIPS_URL,
      hub: EMOC_SERVICES_HUB_URL,
      docsEndPoint: EMOC_SERVICES_DOCS_URL,
      externalEndpoint: EMOC_SERVICES_EXTERNAL_URL,
      externalAuthBaseUrl: EMOC_EXTERNAL_AUTH_BASE_URL,
      externalAuthClientId: EMOC_EXTERNAL_AUTH_CLIENT_ID
    }
  }

  static value(name) {
    const config = this.CONFIG
    return config[name]
  }
}
